/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CpdsLogoWrapper, CpdsLogoLink, CpdsLogoIcon } from './styles/cpds-logo-style';
import { CpdsLogoProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';
import { useStores } from 'src/components/common/utils/useStore';

const CpdsLogo: React.FC<CpdsLogoProps> = (props) => {
  const { context } = useStores();

  const { domRef, exClasses, styleOverrides, themeTypography, type, href, target, partnerLogo, altText } = props;
  const className = themeStyleClass('cpds-logo', themeTypography, exClasses);

  const {
    locale,
    site: { id, domain, brand },
  } = context;

  const siteDomain = domain || 'www.expedia.com';

  let logo = '';

  if (type === 'Icon') {
    logo = `https://a.travel-assets.com/egds/marks/brands/${brand}/app.svg`;
  } else if (type === 'Partner') {
    logo = partnerLogo;
  } else {
    logo = `https://${siteDomain}/_dms/header/logo.svg?locale=${locale}&siteid=${id}`;
  }

  return (
    <>
      {href ? (
        <CpdsLogoLink
          href={href}
          target={target || '_self'}
          className={className}
          ref={domRef}
          styleOverrides={styleOverrides}
        >
          <CpdsLogoIcon alt={altText || 'logo'} src={logo} />
        </CpdsLogoLink>
      ) : (
        <CpdsLogoWrapper className={className} ref={domRef} styleOverrides={styleOverrides}>
          <CpdsLogoIcon alt={altText || 'logo'} src={logo} />
        </CpdsLogoWrapper>
      )}
    </>
  );
};

export default CpdsLogo;
